import { render } from "./myBuzz.vue?vue&type=template&id=a0472068&scoped=true"
import script from "./myBuzz.vue?vue&type=script&lang=js"
export * from "./myBuzz.vue?vue&type=script&lang=js"

import "./myBuzz.vue?vue&type=style&index=0&id=a0472068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0472068"]])

export default __exports__